import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deleteCategory(uuid: string): Promise<AxiosResponse<unknown>> {
  return instance.delete(`/category/${uuid}`)
}
